import {isPlanfixDealPayroll} from '../models/deal-payroll.model';
import {Report} from '../models/report.model';
import {ReportService} from '../services/report.service';
import {PAYROLL_CALCULATION_INDEX} from '../content-page/my-working-report/my-working-report.constants';
import {
  SALARY_CALCULATION_NEGATIVE_MARKER,
  SALARY_CALCULATION_POSITIVE_PREFIX,
  SALARY_CALCULATION_SIGNED_INDEX
} from './report-datepicker.constants';

export function appendFormattedReports(
  reportService: ReportService, reports: Report[]
): void {
  if (!reports) {
    return;
  }
  reports.forEach((report: Report) => {
    formatReportFields(report);
    reportService.reportsMin.push(report);
  });
}

export function formatReportFields(report: Report): void {
  const summary = report.summaryRecord;
  if (!isPlanfixDealPayroll(report)) {
    summary.salarySupplements = Number(summary.salarySupplements);
    summary.wageRate = Number(summary.wageRate);
  }
  const calculations = report.howSalaryCalculated || [];
  calculations.forEach((item: string, index: number) => {
    if (item && !String(item).includes(SALARY_CALCULATION_NEGATIVE_MARKER)
      && !String(item).startsWith(SALARY_CALCULATION_POSITIVE_PREFIX)
      && index > SALARY_CALCULATION_SIGNED_INDEX
      && index <= PAYROLL_CALCULATION_INDEX.LAST_MODIFIER) {
      calculations[index] = SALARY_CALCULATION_POSITIVE_PREFIX + item;
    }
  });
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/report-datepicker-report.mapper.ts